// components/ProtectedRoute.js
import { useAuth } from "../hooks/useAuth";
import { Navigate, useLocation } from "react-router-dom";
import { Spinner } from "react-bootstrap";

export default function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  // Routes qui sont accessibles pendant le processus d'authentification
  const authProcessRoutes = ['/apps/validationOTP'];

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <Spinner animation="border" variant="primary" />
        <span className="ms-2">Vérification de l'authentification...</span>
      </div>
    );
  }

  // Autoriser l'accès aux routes du processus d'authentification
  if (authProcessRoutes.some(route => location.pathname.includes(route))) {
    return children;
  }

  // Rediriger vers la page de connexion si non authentifié
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}